<template>
    <div>
        <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
            <app-sidebar></app-sidebar>
            <div id="page-content-wrapper" style="width:100%">
                <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
                <app-navbar></app-navbar>
                <div class="container-fluid mt-5" id="grad1">
                    <!-- breadcrumb and title row starts -->
                    <div class="row">
                        <div class="col-sm-12">
                            <vs-breadcrumb align="left" :items="[
                      { title: 'You are here : ' },
                     
    
                      {
                        title: 'Event Enclosure',
                        active: true
                      }
                    ]"></vs-breadcrumb>
                        </div>
                        <div class="col-sm-12">
                            <div class="heading mt-2">
                                <h3 class="text-secondary">Event Enclosure</h3>
                            </div>
                        </div>
                    </div>
                    <!-- breadcrumb and title row Ends -->
                    <div class="row justify-content-center mt-0">
                        <div class="col-11 text-center p-0  mb-2">
                            <div class="card px-0 pb-0 mt-3 mb-3">
                                
                                <div class="row">
                                    <div class="col-sm-12">
                                        <b-card>
                                            <div class="row">
                                                <div class="col-6 text-left">
                                                    <h2 style="color:#06a6e0">
                                                         Events Enclosure List
                                                    </h2>
                                                </div>
                                                
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="table-responsive">
                                                            <table class="table custom-table text-left">
                                                                <thead>
                                                                    <tr>
                                                                        <th>ID</th>
                                                                        <th>Title</th>
                                                                        <th>Code</th>
                                                                        <th>Thematic Area</th>
                                                                        <th>Added at</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, index) in items" 
                                                                        v-bind:key="item.id"
                                                                        @click="showDetailModal(item)"
                                                                        class="clickable-row">
                                                                        <td>{{ index + 1 }}</td>
                                                                        <td class="text-capitalize">{{ item.title || '' }}</td>
                                                                        <td>{{ item.training_code || '' }}</td>
                                                                        <td class="text-capitalize">{{ getThematicAreaName(item.thematic_id) }}</td>
                                                                        <td>{{ formatDate2(item.createdAt) }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-card>
    
                                        <!-- new form popup ends -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Add Modal -->
        <b-modal 
            v-model="showModal" 
            title="Event Details" 
            size="lg" 
            @ok="handleSubmit"
            ok-title="Update"
            ok-variant="primary"
            cancel-variant="outline-secondary"
            header-bg-variant="light"
            header-text-variant="primary"
            centered>
            <template #modal-title>
                <h4 class="color-06 mb-0">Event Details</h4>
            </template>
            <div v-if="selectedItem" class="event-details">
                <!-- Event Info Section -->
                <div class="info-section p-3 mb-4 bg-light rounded">
                    <h5 class="mb-3 color-06">Event Information</h5>
                    <div class="row mb-3">
                        <div class="col-4 font-weight-bold text-muted">Title:</div>
                        <div class="col-8">{{ selectedItem.title }}</div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4 font-weight-bold text-muted">Training Code:</div>
                        <div class="col-8">{{ selectedItem.training_code }}</div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4 font-weight-bold text-muted">Thematic Area:</div>
                        <div class="col-8">{{ getThematicAreaName(selectedItem.thematic_id || '') }}</div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4 font-weight-bold text-muted">venue:</div>
                        <div class="col-8">{{ selectedItem.venue || 'N/A' }}</div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4 font-weight-bold text-muted">Created At:</div>
                        <div class="col-8">{{ formatDate2(selectedItem.createdAt) }}</div>
                    </div>
                </div>

                <!-- Status Update Section -->
                <div class="status-section p-3 bg-light rounded">
                    <h5 class="mb-3 color-06">Update Status</h5>
                    <div class="row mb-4">
                        <div class="col-4 font-weight-bold text-muted">Event Status:</div>
                        <div class="col-8">
                            <select 
                                v-model="closure_status" 
                                class="form-control form-control-lg"
                                :class="{ 'is-invalid': submitted && !closure_status }">
                                <option value="">Select Status</option>
                                <option value="Completed">Completed</option>
                                <option value="Cancelled">Cancelled</option>
                                <option value="Postponed">Postponed</option>
                            </select>
                            <div class="invalid-feedback" v-if="submitted && !closure_status">
                                Please select an event status
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </b-modal>
    </div>
</template>
    
<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import {
    formatDate2
} from "@/utils/DateFormate";


export default {
    data: () => ({
       
        isSidebar: false,
        trainingId: "",
        thematicArray: [],
        items: [],
        project: "",
        viewTrainingCode: "",
        showModal: false,
        selectedItem: null,
        closure_status: '',
        close_status: true,
        submitted: false
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.allTrainig();
        // Set the initial number of items
        this.openLoading();
        axios
        .get(localStorage.getItem("BASE_PATH") + "/thematics/get")
        .then(response => {
            
            this.closeLoading();
            this.thematicArray = response.data;
        });
       
    },
    methods: {
        formatDate2,
        // this will show single training wizard
       
     allTrainig() {
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/training/get-past-trainings")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.items = response.data;
                });
        },
    getThematicAreaName(id) {
        const arr = id.split(',')
        const names = [];
        for (const id of arr) {
            const thematicArea = this.thematicArray.find(item => item.id == id);
            if (thematicArea) {
                names.push(thematicArea.name);
            }
        }
        return names.join(', ').replace(/["']/g, '');
    },
       
        resetForm() {
            this.subprogram = "",
                this.project = "",
                this.trainingtitle = "",
                this.advisor = "",
                this.showReference = true;
            this.thematicareaSelectedUpdate = "";
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
       
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        showDetailModal(item) {
            this.selectedItem = item;
            this.closure_status = '';
            this.close_status = true;
            this.submitted = false;
            this.showModal = true;
        },
        handleSubmit(bvModalEvent) {
            bvModalEvent.preventDefault();
            this.submitted = true;
            
            if (!this.closure_status) {
                this.toastError('Please select an event status');
                return;
            }

            this.openLoading();
            axios.put(`${localStorage.getItem("BASE_PATH")}/training/update-closure-status/${this.selectedItem.id}`, {
                closure_status: this.closure_status,
                close_status: this.close_status
            })
            .then(response => {
                this.closeLoading();
                if (response.data) {
                    this.toastSuccess('Status updated successfully');
                    this.showModal = false;
                    this.allTrainig();
                } else {
                    this.toastError(response.data.message || 'Failed to update status');
                }
            })
            .catch(error => {
                this.closeLoading();
                this.toastError(error || 'Error updating status');
                
            });
        }
    },
   

    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        
    },
    
};
</script>

<style scoped>
#grad1 {
    background-color: #fff;
}

.modal-dialog {
    background: transparent !important;
}

.modal-dialog input {
    border-radius: 5px !important;
    height: 32px !important;
}

#bv-modal-example___BV_modal_content_ {
    border-radius: 12px !important;
    background: #f1f1f1 !important;
    border: 1px solid !important;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

.fit-image {
    width: 100%;
    object-fit: cover;
}

.mt-4-training-title {
    margin-top: 27px;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.custom-table thead tr {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
}

.custom-table th {
    padding: 12px 15px;
    font-weight: 600;
}

.custom-table td {
    padding: 12px 15px;
    border-bottom: 1px solid #dee2e6;
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.clickable-row:hover {
    background-color: #f5f5f5;
}

.custom-control-input:checked ~ .custom-control-label::before {
    border-color: #06a6e0;
    background-color: #06a6e0;
}

/* Modal Styles */
.event-details {
    font-size: 1rem;
}

.info-section, .status-section {
    border: 1px solid rgba(0,0,0,0.1);
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.form-control-lg {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control-lg:focus {
    border-color: #06a6e0;
    box-shadow: 0 0 0 0.2rem rgba(6, 166, 224, 0.25);
}

.custom-control-input:checked ~ .custom-control-label::before {
    border-color: #06a6e0;
    background-color: #06a6e0;
}

.custom-checkbox .custom-control-label {
    cursor: pointer;
    user-select: none;
}

.custom-checkbox .custom-control-label:hover::before {
    border-color: #06a6e0;
}

/* Animation for sections */
.info-section, .status-section {
    animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.color-06{
    color: #06a6e0 !important;
}

/* Override bootstrap modal styles */
::v-deep .modal-header {
    border-bottom: 2px solid #06a6e0;
}

::v-deep .btn-primary {
    background-color: #06a6e0 !important;
    border-color: #06a6e0 !important;
}

::v-deep .btn-primary:hover {
    background-color: #0590c2 !important;
    border-color: #0590c2 !important;
}

::v-deep .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem rgba(6, 166, 224, 0.25) !important;
}

.form-control-lg:focus {
    border-color: #06a6e0;
    box-shadow: 0 0 0 0.2rem rgba(6, 166, 224, 0.25);
}

.custom-control-input:checked ~ .custom-control-label::before {
    border-color: #06a6e0;
    background-color: #06a6e0;
}

.custom-checkbox .custom-control-label:hover::before {
    border-color: #06a6e0;
}
</style>
    